import axiosRequest from '@/utils/axios-default-request';

//获取选择题
let getXuanZeData =(data)=> axiosRequest.postBodyJson('/supinterface/getXuanZeData',data)

// 提交选择题测试
let addXuanZe =(data)=> axiosRequest.postBodyJson('/supinterface/addXuanZe',data)

// 获取选择题记录
let getXuanZeJL = (data)=>axiosRequest.postBody('/supinterface/getXuanZeJL',data)

// 获取选择语种
let getYycsYzData = (data)=>axiosRequest.postBody('/supinterface/getYycsYzData',data)

// 获取已开放语言测试的语种对
let getYkfYzdData = (data)=>axiosRequest.postBody('/supinterface/getYkfYzdData',data)


export default{
    getXuanZeData,// 获取选择题
    addXuanZe,// 提交选择题
    getXuanZeJL,// 获取选择题记录
    getYycsYzData,// 获取选择育种
    getYkfYzdData,// 获取已开放语言测试的语种对
}